module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": _vm.type.border,
      "stripe": _vm.type.stripe,
      "default-sort": {
        prop: 'id',
        order: 'ascending'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-form', {
          staticClass: "table-expand",
          attrs: {
            "label-position": "left",
            "inline": ""
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "name"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.name))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "team"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.team))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "ID"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.id))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "feature"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.feature))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "description"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.desc))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "bounty"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.bounty))])])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "ID",
      "sortable": "",
      "prop": "id",
      "width": 100
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Name",
      "sortable": "",
      "prop": "name",
      "width": 120
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Fight rate",
      "width": 150
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-rate', {
          attrs: {
            "disabled": ""
          },
          model: {
            value: (scope.row.rate),
            callback: function($$v) {
              scope.row.rate = $$v
            },
            expression: "scope.row.rate"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Description",
      "sortable": "",
      "prop": "desc"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Feature",
      "prop": "feature",
      "width": 150
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Bounty",
      "sortable": "",
      "prop": "bounty",
      "width": 120
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Team",
      "prop": "team",
      "width": 250
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "width": 150
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "plain": true,
            "type": "info"
          },
          on: {
            "click": function($event) {
              _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("edit")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              _vm.handleDelete(scope.$index, scope.row)
            }
          }
        }, [_vm._v("delete")])]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66fc993c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/table.vue
// module id = 603
// module chunks = 1